import { PageHeader } from '@/components/shared/PageHeader';
import { EmptyState } from '@/components/shared/EmptyState';

// Stand-by app — placeholder finché non si attiva la prima verticale intermediari.
// Vedi project_frontend_decisions.md rev 3 — sequencing backoffice-first.
export function PlaceholderPage(): JSX.Element {
  return (
    <div>
      <PageHeader
        title="Intermediari"
        description="App in stand-by. La prima verticale intermediari verrà attivata dopo che Portafoglio + Sinistri backoffice sono in produzione interna."
      />
      <EmptyState
        title="Stand-by"
        description="Lo scaffolding strutturale è in piedi (cross-cutting layer + shell). Nessuna feature reale prima della riapertura del gate."
      />
    </div>
  );
}
